exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "label {\r\n\tfont-size: 10pt;\r\n\tfont-weight: normal;\r\n\tcolor: #444;\r\n}\r\n\r\n.highLightCellGreen {\r\n\tcolor: green;\r\n\tbackground-color: #dff0d8;\r\n}\r\n.highLightCellRed {\r\n\tcolor: #880000;\r\n\tbackground-color: #f2dede;\r\n}\r\n.highLightCellOrange {\r\n\tcolor: #ff6600;\r\n\tbackground-color: #ffcc99;\r\n}\r\n\r\n.highLightCellBlue {\r\n\tcolor: #31708f;\r\n\tbackground-color: #d9edf7;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/users-prospect/users-prospect.component.css
// module id = 364
// module chunks = 0